import { render, staticRenderFns } from "./excuses.vue?vue&type=template&id=d61acf18&"
import script from "./excuses.vue?vue&type=script&lang=js&"
export * from "./excuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "excuses.vue"
export default component.exports